import * as React from "react";

import {isNonNullable} from "@khanacademy/wonder-stuff-core";
import {Persist, useFastlyQuery} from "@khan/data-gql";

import {LOCALES_QUERY} from "./locales-query.ts";

export interface Locale {
    id: string;
    localName: string;
    isSupportedInKhanClassroom: boolean;
}

interface LocalesQueryResult {
    locales: Array<Locale>;
    isLoading: boolean;
    isError: boolean;
}
export const useLocalesQuery = (): LocalesQueryResult => {
    const result = useFastlyQuery(LOCALES_QUERY, {
        cachingPolicy: Persist.AcrossPublish,
    });

    return React.useMemo(() => {
        const localesForLanguagePicker =
            result.status === "success"
                ? result.data.localesForLanguagePicker
                : null;

        if (result.status === "loading" || !localesForLanguagePicker) {
            return {
                isError: result.status === "error",
                isLoading: result.status === "loading",
                locales: [],
            };
        }

        const locales = [...localesForLanguagePicker]
            .reduce((acc: Locale[], locale) => {
                if (
                    isNonNullable(locale) &&
                    isNonNullable(locale.localName) &&
                    isNonNullable(locale.id)
                ) {
                    acc.push({
                        id: locale.id,
                        localName: locale.localName,
                        isSupportedInKhanClassroom:
                            locale.isSupportedInKhanClassroom,
                    });
                }
                return acc;
            }, [])
            .sort((a, b): number => a.localName.localeCompare(b.localName));

        return {
            isError: false,
            isLoading: false,
            locales,
        };
    }, [result]);
};

export default useLocalesQuery;
